// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__B4mvt","title":"styles_title__fi-5p","overviewTable":"styles_overviewTable__kWb44"};